import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function AcceptIcon(props: SvgIconProps) {
	return (
		<SvgIcon {...props} viewBox="0 0 12 12">
			<circle
				cx="6.39996"
				cy="6.00006"
				r="5.94"
				fill="#4EBC78"
				fillOpacity={0.2}
			/>
			<path
				d="M3.25464 5.65043L5.70052 8.79513L9.19464 3.55396"
				stroke="#4EBC78"
				strokeWidth={0.99}
			/>
		</SvgIcon>
	);
}
